export default __webpack_public_path__ + "static/media/white.29a85cc1.svg";